"use strict";

/** @format */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildImageSrcUsingSourceImg = buildImageSrcUsingSourceImg;
exports.buildImageSrcUsingProductImageData = buildImageSrcUsingProductImageData;
exports.imageHeightWidth = imageHeightWidth;
const data_1 = require("../../data");
/** @format */
const imageHost = data_1.imageUrlData.imageHost;
function buildImageSrcUsingSourceImg(sourceImg, width, imgFormat) {
  let imageSrc = '';
  if (typeof sourceImg === 'string') {
    imageSrc = sourceImg;
  } else {
    imageSrc = `${sourceImg.templateSrc || sourceImg.poster}?qlt=70&wid=${width}&fmt=${imgFormat || 'webp'}&op_sharpen=1`;
  }
  return imageSrc;
}
function buildImageSrcUsingProductImageData(imageData, ecode, isBrowser, windowObj, selectedSwatchColor) {
  const imgColor = selectedSwatchColor || imageData.defaultColor;
  const color = imgColor?.replace(/[^\w]/gi, '_');
  let imageSrc = '';
  let imagePath = '';
  if (isBrowser && windowObj.location.hostname.includes(`dksxchange`) && !windowObj.location.hostname.includes(`prod-`)) {
    imagePath = `${imageHost}GolfGalaxyTest`;
  } else {
    imagePath = `${imageHost}dkscdn`;
  }
  if (imageData.imageUrl) {
    imageSrc = color ? imageData.imageUrl.replace(/_([^?]+)/, `_${color}`) : imageData.imageUrl;
    imageSrc = imageHeightWidth(imageSrc, imageData);
  } else {
    const imageWidth = imageData.width ? imageData.width : '252';
    const imageHeight = imageData.height ? imageData.height : '252';
    imageSrc = color ? `${imagePath}/${ecode}_${color}_is/?wid=${imageWidth}&hei=${imageHeight}&qlt=85,0&fmt=jpg&op_sharpen=1` : `${imagePath}/${ecode}_is/?wid=${imageWidth}&hei=${imageHeight}&qlt=85,0&fmt=jpg&op_sharpen=1`;
  }
  return imageSrc;
}
function imageHeightWidth(imageSrc, imageData) {
  if (!imageSrc.includes('&wid=') && !imageSrc.includes('?wid=') && imageData.width) {
    imageSrc += '&wid=' + imageData.width;
  }
  if (!imageSrc.includes('&hei=') && !imageSrc.includes('?hei=') && imageData.height) {
    imageSrc += '&hei=' + imageData.height;
  }
  return imageSrc;
}
